import PageHeader from "@/components/shared/PageHeader";
import CTASection from "@/components/shared/CTASection";
import { EXEC_EDUCATION_PROGRAMMES } from "@/data/content";
import { GraduationCap } from "lucide-react";

export default function ExecutiveEducation() {
  return (
    <>
      <PageHeader
        overline="Executive Education"
        title="Practical programmes for leaders who need to govern resilience with confidence."
        lead="Compact, audit-ready learning for policymakers, boards, executives, research leads, and technology leaders — built around the decisions you will actually be asked to take."
      />

      <section className="ccdr-section">
        <div className="ccdr-container grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <GraduationCap className="w-9 h-9 mb-5" style={{ color: "var(--ccdr-primary)" }} />
            <p className="ccdr-eyebrow mb-5">Why a programme, not a course</p>
            <h2 className="ccdr-h2">Built around real decisions.</h2>
          </div>
          <div className="lg:col-span-7 ccdr-prose">
            <p>
              Resilience leadership is not a single skill. It is the practised judgement to read frameworks, weigh
              standards, hold technology to account, and protect the people most exposed. The Centre&apos;s programmes
              are short, by invitation or cohort, and structured around the framework instruments that will sit on a
              leader&apos;s desk in the next twelve months.
            </p>
            <p>
              Each programme combines a private briefing, a working session with peers, and follow-up working tools.
              The Centre&apos;s independent and evidence-led posture applies: programmes reference recognised global
              bodies as authoritative sources and translate, rather than promote.
            </p>
          </div>
        </div>

        <div className="ccdr-container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#E5E7EB] border border-[#E5E7EB]">
            {EXEC_EDUCATION_PROGRAMMES.map((p, i) => (
              <article key={p.name} className="bg-white p-10">
                <div className="flex items-center justify-between mb-5">
                  <span className="ccdr-overline">Programme 0{i + 1}</span>
                  <span
                    className="text-xs px-3 py-1 border border-[#E5E7EB] text-[#4B5563]"
                  >
                    {p.audience}
                  </span>
                </div>
                <h3 className="ccdr-h3 mb-3">{p.name}</h3>
                <p className="text-[#4B5563] leading-relaxed mb-5">{p.body}</p>
                <p
                  className="text-xs uppercase tracking-[0.22em]"
                  style={{ color: "var(--ccdr-accent-dark)" }}
                >
                  Cadence · {p.cadence}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Request a programme or invite the Centre to brief your institution."
        primary={{ to: "/get-involved", label: "Get in touch" }}
      />
    </>
  );
}
